import { Component, OnInit } from '@angular/core';
import { JWTTokenService } from '../../shared/service/jwt-token-service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(
    private jwtTokenService: JWTTokenService,
    private activatedRoute: ActivatedRoute,
    private router: Router) { }

  ngOnInit() {
    this.activatedRoute.queryParams
      .subscribe(async params => {
          if (params.token) {
            this.jwtTokenService.setToken(params.token);
            await this.router.navigate(['/home'], { relativeTo: this.activatedRoute, queryParams: {} });
          }
        }
      );
  }
  loginWithGoogle(): void {
    window.location.href = `${environment.ssoUrl + environment.ssoAuthUrl}`;
  }

}
